const loadingFeatures = [
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'one',
        project: 'default',
        reviveName: 'cool-thing',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'two',
        project: 'default',
        reviveName: 'cool-thing',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'three',
        project: 'default',
        reviveName: 'cool-thing',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'four',
        project: 'default',
        reviveName: 'cool-thing',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'five',
        project: 'default',
        reviveName: 'cool-thing',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'six',
        project: 'default',
        reviveName: 'cool-thing',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'seven',
        project: 'default',
        reviveName: 'cool-thing',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'eight',
        project: 'default',
        reviveName: 'cool-thing',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'nine',
        project: 'default',
        reviveName: 'cool-thing',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
    {
        createdAt: '2021-03-19T09:16:21.329Z',
        description: '',
        enabled: true,
        lastSeenAt: '2021-03-24T10:46:38.036Z',
        name: 'ten',
        project: 'default',
        reviveName: 'cool-thing',
        stale: true,
        strategies: [],
        variants: [],
        type: 'release',
    },
];

export default loadingFeatures;
